module.exports = __webpack_public_path__ + "img/icon-supply1.30b63b84.png";